<template>
  <div class="event-status" v-if="event">
    <a @click="toggleHide" v-if="trackerChange">tracker</a>
    <span v-if="!trackerChange">tracker</span>
    <span>:</span>
    <span style="color: green" v-if="!event.hidden">
      visible
      <span v-if="downloadable">+ download</span>
    </span>
    <span style="color: red" v-if="event.hidden">hidden</span>
    <span v-if="event.dealt == 0 || event.dealt == 1">
      <span>&#160;&#160;&#160;</span>
      <a @click="toggleDealt">dealt</a>
      <span>:</span>
      <span style="background: red; color: white" v-if="event.dealt == 0"
        >NO</span
      >
      <span style="color: green" v-if="event.dealt == 1">yes</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "Status",
  props: {
    event: null
  },
  computed: {
    trackerChange() {
      return ["note", "upload"].includes(this.event.subType);
      // return (
      //   this.event.dealt == 0 || this.event.dealt == 1 || this.event.dealt == 4
      // );
    },
    downloadable() {
      return this.event.clientDownload != undefined &&
        this.event.clientDownload == true
        ? true
        : false;
    }
  },
  methods: {
    toggleHide() {
      const hidden = !this.event.hidden;
      if (this.event.subType === "note") {
        this.$emit("hideNote", {
          id: Number(this.$route.params.id),
          noteid: this.event.id,
          value: hidden
        });
      } else if (this.event.subType === "upload") {
        this.$emit("hideUpload", {
          id: Number(this.$route.params.id),
          uploadfileid: this.event.id,
          value: hidden
        });
      }
    },
    toggleDealt() {
      const dealt = !this.event.dealt;
      if (this.event.subType === "note") {
        this.$emit("dealtNote", {
          id: Number(this.$route.params.id),
          noteid: this.event.id,
          value: dealt
        });
      } else if (this.event.subType === "email") {
        this.$emit("dealtEmail", {
          id: Number(this.$route.params.id),
          emailid: this.event.id,
          value: dealt
        });
      }
    }
  }
};
</script>

<style>
.event-status {
  font-size: 0.9rem;
}
@media print {
  .event-status {
    display: none;
  }
}
</style>